<template>
  <div class="fl-sym-px-4" >
    <div class="fl-sym-flex fl-sym-mt-20 fl-sym-justify-center">
      <AddNewPet />
      <PetSlider/>
    </div>

    <div class="fl-sym-mt-10 xs:fl-sym-mt-10 sm:fl-sym-mt-10 fl-sym-mb-2">
      <button
        type="submit"
        @click="start_sc"
        class="fl-sym-bg-primary fl-sym-mt-8 fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm symptom-btn"
      >
        Start symptom checker
      </button>

      <button
        type="submit"
        class="fl-sym-bg-primary fl-sym-mt-4 fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm email-password hover:fl-sym-border-primary"
      >
        <router-link
          class="fl-sym-text-primary fl-sym-font-bold"
          :to="{ name: 'register-step-2' }"
        >
          Medical history
          <font-awesome-icon
            icon="chevron-right"
            class="fl-sym-ml-13 fl-sym-float-right"
          ></font-awesome-icon>
        </router-link>
      </button>

      <button
        type="submit"
        class="fl-sym-bg-primary fl-sym-mt-2 fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm email-password hover:fl-sym-border-primary"
      >
        <router-link
          class="fl-sym-text-primary fl-sym-font-bold"
          :to="{ name: 'register-step-2' }"
        >
          Track symptoms
          <font-awesome-icon
            icon="chevron-right"
            class="fl-sym-ml-13 fl-sym-float-right"
          ></font-awesome-icon>
        </router-link>
      </button>

      <button
        type="submit"
        class="fl-sym-bg-primary fl-sym-mt-2 fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm email-password hover:fl-sym-border-primary"
      >
        <router-link
          class="fl-sym-text-primary fl-sym-font-bold"
          :to="{ name: 'register-step-2' }"
        >
          Lorem ipsum
          <font-awesome-icon
            icon="chevron-right"
            class="fl-sym-ml-13 fl-sym-float-right"
          ></font-awesome-icon>
        </router-link>
      </button>

      <button
        class="fl-sym-mt-8 fl-sym-bg-primary fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm already-account"
        @click="logout"
      >
        Log out
      </button>
    </div>
  </div>
</template>

<script>
import AddNewPet from "@/components/pet/AddNewPet.vue"
import { mapState } from "vuex"
import PetSlider from "../../components/pet/PetSlider";
export default {
  components: {PetSlider, AddNewPet },
  data() {
    return {
      errors: [],
      email: null,
      password: null,
      email_input: null,
      password_input: null,
    }
  },
  computed: {
    ...mapState({
      pets: (state) => state.pet.pets,
    }),
  },
  mounted() {
    this.getPets()
  },
  methods: {
    getPets() {
      this.$store.dispatch("pet/fetchPetList")
    },
    async start_sc() {
      await this.$store.dispatch("sc/begin")
      await this.$router.push({ name: process.env.VUE_APP_SYMPTOM_CHECKER_BEGIN })
    },
    async logout() {
      await this.$store.dispatch("auth/logout")
    },
  },
}
</script>

<style>
.error {
  top: 460px;
  left: 20px;
  width: 366px;
  height: 16px;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font: "SFProDisplay-Regular";
  font-size: 16px;
  color: #ff3a19;
}

.border-red {
  border-color: #ff3a19;
}

.symptom-btn {
  color: var(--unnamed-color-ffffff);
  text-align: center;
  letter-spacing: 0.64px;
  color: #ffffff;
  background: transparent
    linear-gradient(262deg, #19e0ff 0%, var(--progress-bar-filler) 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(262deg, #19e0ff 0%, #00c5e3 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
  border: 2px solid transparent;
}
.symptom-btn:hover {
  color: hsl(0deg 0% 100% / 85%);
}

.email-password {
  background-color: white;
  color: black;
  border: 2px solid #707070;
}
p.fl-plus {
  font-size: 36px;
  font-family: "SF Pro Display Light";
  font-weight: 100;
  position: relative;
  bottom: 2px;
  left: -0.5px;
}

.fl-circle:hover {
  background: #00c8e34d;
}
.back {
  font-family: "SFProDisplay-Semibold";
}

.already-account {
  color: var(--unnamed-color-6f7878);
  text-align: center;
  letter-spacing: 0.64px;
  color: #6f7878;
  background-color: #d0dada;
  opacity: 0.6;
}
.already-account:hover {
  color: black;
}
.email-password-text {
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 0.64px;
  color: #00c5e3;
  opacity: 1;
}

.heading {
  letter-spacing: var(--unnamed-character-spacing--0-2);
  color: var(--unnamed-color-000000);
  text-align: left;
  letter-spacing: -0.2px;
  color: #000000;
  font-weight: bold;
  opacity: 1;
}

.update-text {
  font: var(--unnamed-font-style-normal) normal
    var(--unnamed-font-weight-normal) var(--unnamed-font-size-17) /
    var(--unnamed-line-spacing-22) var(--unnamed-font-family-sf-pro-display);
  letter-spacing: var(--unnamed-character-spacing-0-56);
  color: var(--unnamed-color-6f7878);
  text-align: left;
  font: normal normal normal 17px/22px SF Pro Display;
  letter-spacing: 0.56px;
  color: #6f7878;
  opacity: 1;
}
</style>
